module.exports = __webpack_public_path__ + "static/media/Rating Page.2525d760.png";